import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  Search,
  Calculator,
  MessageCircle,
  BookOpen,
  ArrowRight,
} from "lucide-react";

const cards = [
  {
    icon: Search,
    title: "Nursing Home Directory",
    description:
      "Browse 560+ nursing homes across every county in Ireland with detailed profiles, HIQA data, and real family insights.",
    href: "/nursing-homes",
    accent: "bg-accent",
  },
  {
    icon: Calculator,
    title: "Fair Deal Calculator",
    description:
      "Estimate your nursing home contributions under the Fair Deal scheme in minutes — no jargon, just clear numbers.",
    href: "/fair-deal-calculator",
    accent: "bg-[hsl(var(--secondary))]",
  },
  {
    icon: MessageCircle,
    title: "Free Care Advisor",
    description:
      "Not sure where to start? Chat instantly for free guidance on care options, Fair Deal applications, and next steps.",
    href: "/consultations",
    accent: "bg-accent",
  },
  {
    icon: BookOpen,
    title: "Guides & Resources",
    description:
      "Step-by-step guides on finding a nursing home, understanding Fair Deal, and making the transition smoother for everyone.",
    href: "/guides",
    accent: "bg-[hsl(var(--secondary))]",
  },
];

export default function ValuePropositions() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-card">
      <div className="container">
        <div className="text-center mb-14">
          <h2 className="section-title mb-4">
            Everything you need, in one place
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We built Grandpal because we've been where you are. Here's how we
            help.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {cards.map((card, i) => (
            <motion.button
              key={card.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              onClick={() => navigate(card.href)}
              className="text-left p-6 md:p-8 rounded-2xl border border-border bg-background hover:shadow-lg hover:border-primary/20 transition-all duration-300 group cursor-pointer"
            >
              <div
                className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${card.accent} mb-5`}
              >
                <card.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2 font-lora">
                {card.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                {card.description}
              </p>
              <span className="inline-flex items-center text-sm font-medium text-primary group-hover:gap-2 gap-1 transition-all">
                Learn more
                <ArrowRight className="h-4 w-4" />
              </span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
